<div class="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between" style="padding: 25px 25px 0">
  <div class="flex flex-col gap-1">
    <span class="text-black font-black uppercase">Catálogo de Produtos</span>
    <small class="text-xs text-chathams-blue"
      >Importe, preencha manualmente ou carregue um catálogo já existente de skincare.</small
    >
  </div>

  <a
    routerLink="/dash/classificacao-skincare"
    class="h-9 px-4 btn btn--secondary inline-flex items-center justify-center whitespace-nowrap"
  >
    Abrir classificação dos resultados
  </a>
</div>

<div class="flex items-start gap-4" style="padding: 0 25px 25px">
  <app-company-sidebar
    [companies]="companies"
    [selectedCompanyId]="form.getRawValue().companyId"
    [disabled]="form.get('companyId')?.disabled ?? false"
    (companySelected)="onCompanySidebarSelected($event)"
  ></app-company-sidebar>

  <form class="flex flex-col gap-6 flex-1 min-w-0" [formGroup]="form">
    <div class="bg-white rounded-2xl shadow-md px-6 py-5 flex flex-col gap-5">
      <app-catalog-empty-state *ngIf="!form.get('companyId')?.value" state="no-company"> </app-catalog-empty-state>

      <ng-container *ngIf="form.get('companyId')?.value">
        <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
          <div class="rounded-xl border border-gray-200 px-4 py-3 flex items-start justify-between gap-2">
            <div class="flex flex-col gap-0.5 min-w-0">
              <span class="text-xs font-bold uppercase text-gray-400">Catálogo</span>
              <span class="text-sm text-chathams-blue truncate"
                >{{ catalogProductCount }} produto(s) · {{ catalogStatusLabel }}</span
              >
            </div>
          </div>

          <div class="rounded-xl border border-gray-200 px-4 py-3 flex items-start justify-between gap-2">
            <div class="flex flex-col gap-0.5 min-w-0">
              <span class="text-xs font-bold uppercase text-gray-400">Questionário</span>
              <span class="text-sm text-chathams-blue truncate">{{
                isLoadingExistingCatalog ? 'Carregando...' : questionsStatusLabel
              }}</span>
            </div>
            <a
              routerLink="/dash/questionario-skincare"
              title="Editar questionário"
              class="shrink-0 inline-flex items-center justify-center w-7 h-7 rounded-lg hover:bg-gray-100"
            >
              <lucide-icon name="pencil" [size]="14" class="text-chathams-blue"></lucide-icon>
            </a>
          </div>

          <div class="rounded-xl border border-gray-200 px-4 py-3 flex items-start justify-between gap-2">
            <div class="flex flex-col gap-0.5 min-w-0">
              <span class="text-xs font-bold uppercase text-gray-400">Classificação</span>
              <span class="text-sm text-chathams-blue truncate">{{
                isLoadingExistingCatalog ? 'Carregando...' : thresholdStatusLabel
              }}</span>
            </div>
            <a
              routerLink="/dash/classificacao-skincare"
              title="Editar classificação"
              class="shrink-0 inline-flex items-center justify-center w-7 h-7 rounded-lg hover:bg-gray-100"
            >
              <lucide-icon name="pencil" [size]="14" class="text-chathams-blue"></lucide-icon>
            </a>
          </div>

          <div class="rounded-xl border border-gray-200 px-4 py-3 flex items-start justify-between gap-2">
            <div class="flex flex-col gap-0.5 min-w-0">
              <span class="text-xs font-bold uppercase text-gray-400">Kits</span>
              <span class="text-sm text-chathams-blue truncate">{{
                isLoadingExistingCatalog ? 'Carregando...' : kitMatrixStatusLabel
              }}</span>
            </div>
            <a
              routerLink="/dash/motor-kits-skincare"
              title="Editar kits"
              class="shrink-0 inline-flex items-center justify-center w-7 h-7 rounded-lg hover:bg-gray-100"
            >
              <lucide-icon name="pencil" [size]="14" class="text-chathams-blue"></lucide-icon>
            </a>
          </div>
        </div>

        <div class="flex border-b border-gray-200 -mx-6 px-6">
          <button
            type="button"
            class="px-5 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors"
            [style.border-color]="mode === 'upload' ? 'var(--buttons-background)' : 'transparent'"
            [style.color]="mode === 'upload' ? 'var(--buttons-background)' : '#9ca3af'"
            (click)="activateMode('upload')"
          >
            Importar arquivo
          </button>
          <button
            type="button"
            class="px-5 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors"
            [style.border-color]="mode === 'manual' ? 'var(--buttons-background)' : 'transparent'"
            [style.color]="mode === 'manual' ? 'var(--buttons-background)' : '#9ca3af'"
            (click)="activateMode('manual')"
          >
            Preencher manualmente
          </button>
        </div>

        <div class="form-group" *ngIf="mode === 'upload' && (catalogSource !== 'company' || userActivatedMode)">
          <label
            class="flex flex-col items-center justify-center gap-4 cursor-pointer border-2 border-dashed border-gray-300 rounded-xl px-6 py-10 hover:border-gray-400 transition-colors bg-gray-50 text-center"
          >
            <lucide-icon name="upload" [size]="40" class="text-gray-400"></lucide-icon>
            <div>
              <p class="text-sm font-semibold text-chathams-blue">
                {{ fileName || 'Arraste ou clique para selecionar o arquivo' }}
              </p>
              <p class="text-xs text-gray-400 mt-1">Formatos aceitos: CSV ou XLSX</p>
            </div>
            <span class="btn btn--primary text-sm px-5 h-9 flex items-center">Escolher arquivo</span>
            <input
              type="file"
              class="hidden"
              accept=".csv,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              (change)="onFileSelected($event)"
            />
          </label>
        </div>

        <app-catalog-empty-state
          *ngIf="catalogSource === null && !isLoadingExistingCatalog && !userActivatedMode"
          state="no-catalog"
          (importClicked)="activateMode('upload')"
          (manualClicked)="activateMode('manual')"
        >
        </app-catalog-empty-state>

        <div *ngIf="catalogSource === 'company' || userActivatedMode" class="flex flex-col gap-4">
          <div class="flex flex-wrap items-center justify-between gap-3">
            <span class="text-sm font-bold tracking-wider uppercase text-chathams-blue">
              {{ mode === 'manual' ? 'Produtos do catálogo' : 'Produtos importados' }}
            </span>
            <div class="flex flex-wrap items-center gap-2 w-full md:w-auto">
              <div class="form-group w-full md:w-72">
                <input
                  class="form-input"
                  placeholder="Pesquisar produto por nome"
                  [ngModel]="searchProductName"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="onSearchProductNameChange($event)"
                  name="searchProductName"
                />
              </div>
              <button
                *ngIf="searchProductName"
                type="button"
                class="h-9 px-4 btn btn--secondary"
                (click)="clearProductSearch()"
              >
                Limpar
              </button>
              <button *ngIf="mode === 'manual'" type="button" class="h-9 px-4 btn btn--primary" (click)="addRow()">
                Adicionar produto
              </button>
            </div>
          </div>

          <p class="text-sm text-chathams-blue" *ngIf="mode === 'upload' && !currentRows.length && previewMessage">
            {{ previewMessage }}
          </p>
          <p class="text-sm text-chathams-blue" *ngIf="mode === 'upload' && !currentRows.length && !previewMessage">
            Carregue um arquivo CSV ou XLSX para visualizar, editar ou remover produtos.
          </p>

          <p class="text-sm text-chathams-blue" *ngIf="currentRows.length && !filteredRows.length">
            Nenhum produto encontrado para "{{ searchProductName }}".
          </p>

          <div class="overflow-x-auto" *ngIf="filteredRows.length">
            <table class="min-w-full">
              <thead class="border-b border-gray-400">
                <tr>
                  <th class="px-4 py-3 text-left text-xs font-bold uppercase text-chathams-blue">Imagem</th>
                  <th class="px-4 py-3 text-left text-xs font-bold uppercase text-chathams-blue">Item</th>
                  <th class="px-4 py-3 text-left text-xs font-bold uppercase text-chathams-blue">Marca</th>
                  <th class="px-4 py-3 text-left text-xs font-bold uppercase text-chathams-blue">Produto</th>
                  <th class="px-4 py-3 text-left text-xs font-bold uppercase text-chathams-blue">Categorias</th>
                  <th class="px-4 py-3 text-left text-xs font-bold uppercase text-chathams-blue">Rotina</th>
                  <th class="px-4 py-3 text-left text-xs font-bold uppercase text-chathams-blue">Peso</th>
                  <th class="px-4 py-3 text-left text-xs font-bold uppercase text-chathams-blue">Preço</th>
                  <th class="px-4 py-3 text-center text-xs font-bold uppercase text-chathams-blue">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr class="bg-white hover:bg-iceberg" *ngFor="let row of pagedRows; let i = index">
                  <td class="px-4 py-3">
                    <img
                      *ngIf="row.productPhotoLink; else noImage"
                      class="w-10 h-10 object-cover rounded"
                      [src]="row.productPhotoLink"
                      [alt]="row.productName || 'Produto'"
                      (error)="row.productPhotoLink = ''"
                    />
                    <ng-template #noImage>
                      <span class="text-sm text-chathams-blue">-</span>
                    </ng-template>
                  </td>
                  <td class="px-4 py-3 text-sm text-chathams-blue">{{ row.itemNumber || '-' }}</td>
                  <td class="px-4 py-3 text-sm text-chathams-blue">{{ row.brandName || '-' }}</td>
                  <td class="px-4 py-3 text-sm text-chathams-blue">{{ row.productName || '-' }}</td>
                  <td class="px-4 py-3 text-sm text-chathams-blue">{{ row.categories || '-' }}</td>
                  <td class="px-4 py-3 text-sm text-chathams-blue">{{ row.routineInformation || '-' }}</td>
                  <td class="px-4 py-3 text-sm text-chathams-blue">{{ row.weight || '-' }}</td>
                  <td class="px-4 py-3 text-sm text-chathams-blue whitespace-nowrap">{{ getPriceLabel(row.price) }}</td>
                  <td class="px-4 py-3">
                    <div class="flex justify-center gap-1">
                      <button
                        type="button"
                        class="inline-flex items-center justify-center w-8 h-8 rounded-lg hover:bg-gray-100 transition-colors"
                        title="Editar"
                        (click)="editRow(getRowIndex(i))"
                      >
                        <lucide-icon name="pencil" [size]="16" class="text-chathams-blue"></lucide-icon>
                      </button>
                      <button
                        type="button"
                        class="inline-flex items-center justify-center w-8 h-8 rounded-lg hover:bg-red-50 transition-colors"
                        title="Remover"
                        (click)="removeRow(getRowIndex(i))"
                      >
                        <lucide-icon name="trash-2" [size]="16" class="text-cerise-red-600"></lucide-icon>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <app-paginacao
            *ngIf="filteredRows.length"
            [numeroDeItens]="filteredRows.length"
            [totalPage]="totalPaginas"
            [paginaSelecionada]="paginaSelecionada"
            [tamanhoDaPagina]="tamanhoPagina"
            (mudouPagina)="setPage($event)"
            (mudouTamanhoPagina)="setPageSize($event)"
          ></app-paginacao>

          <app-catalog-product-dialog
            [row]="activeRow"
            [questions]="questions"
            [isCreating]="isCreatingProduct"
            (saved)="onDialogSaved($event)"
            (cancelled)="onDialogCancelled()"
          >
          </app-catalog-product-dialog>
        </div>
      </ng-container>

      <div class="flex justify-end" *ngIf="form.get('companyId')?.value">
        <button
          *isAllowed="[ERoleAdminString.Master, ERoleAdminString.Admin, 'skincare.import']"
          type="button"
          class="w-80 h-9 btn btn--secondary"
          [disabled]="
            form.get('companyId')?.invalid ||
            isUploading ||
            isLoadingExistingCatalog ||
            (mode === 'upload' && form.get('file')?.invalid && !importedRows.length) ||
            (mode === 'manual' && !manualHasData())
          "
          (click)="uploadCatalog()"
        >
          {{
            isUploading
              ? 'Enviando...'
              : isCatalogLoadedFromServer
                ? 'Salvar alterações do catálogo'
                : 'Cadastrar catálogo'
          }}
        </button>
      </div>
    </div>
  </form>
</div>
